<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ 'catering.title' | translate }}</h2>
      <p class="page-sub">
        {{ 'catering.subtitle' | translate }}
      </p>
    </div>
  </div>

  <div class="state" *ngIf="loading">Loading…</div>
  <div class="state error" *ngIf="error && !loading">{{ error }}</div>

  <ng-container *ngIf="!loading">

    <div class="notice" *ngIf="!systems.length">
      <mat-icon>info</mat-icon>
      <span>{{ 'catering.noCanteen' | translate }}</span>
    </div>

    <div class="notice" *ngIf="systems.length && !canOrder">
      <mat-icon>lock</mat-icon>
      <span>{{ 'catering.readOnly' | translate }}</span>
    </div>

    <!-- ---- the order form ---- -->
    <ng-container *ngIf="systems.length && canOrder">
      <h3 class="section-title">{{ 'catering.newOrder' | translate }}</h3>

      <div class="card">
        <div class="toolbar">
          <mat-form-field appearance="outline" class="pick-field" *ngIf="systems.length > 1">
            <mat-label>{{ 'catering.location' | translate }}</mat-label>
            <mat-select [(ngModel)]="systemDocId">
              <mat-option *ngFor="let s of systems" [value]="s.id">{{ s.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="pick-field">
            <mat-label>{{ 'catering.deliveryDate' | translate }}</mat-label>
            <mat-select [(ngModel)]="date" (selectionChange)="onDateChange()">
              <mat-option *ngFor="let d of dates" [value]="d">{{ dateLabel(d) }}</mat-option>
            </mat-select>
          </mat-form-field>

          <span class="lead-note" *ngIf="!date">
            {{ 'catering.datesNote' | translate }}
          </span>
        </div>

        <div class="state" *ngIf="loadingMenu">{{ 'catering.loadingMenu' | translate }}</div>

        <ng-container *ngIf="date && !loadingMenu">
          <div class="notice" *ngIf="!menuPlanned">
            <mat-icon>event_busy</mat-icon>
            <span>{{ 'catering.menuNotPublished' | translate }}</span>
          </div>

          <div class="notice" *ngIf="menuPlanned && !menuLocked">
            <mat-icon>info</mat-icon>
            <span>{{ 'catering.menuNotFinal' | translate }}</span>
          </div>

          <div class="table-wrap" *ngIf="menuPlanned && items.length">
            <table class="data">
              <thead>
                <tr>
                  <th>{{ 'catering.colProduct' | translate }}</th>
                  <th class="num">{{ 'catering.colPrice' | translate }}</th>
                  <th class="num">{{ 'catering.colMin' | translate }}</th>
                  <th class="num qty-col">{{ 'catering.colQuantity' | translate }}</th>
                  <th class="num">{{ 'catering.colSum' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of items" [class.row-chosen]="item.qty > 0"
                    [class.row-warn]="item.qty > 0 && item.qty < item.min">
                  <td>
                    <div class="prod-name">{{ item.name }}</div>
                    <div class="prod-sub" *ngIf="item.description">{{ item.description }}</div>
                    <div class="prod-tags">
                      <span class="tag" *ngIf="item.isVegetar">{{ 'catering.tagVegetarian' | translate }}</span>
                      <span class="tag" *ngIf="item.isGlutenFri">{{ 'catering.tagGlutenFree' | translate }}</span>
                      <span class="tag" *ngIf="item.isLaktoseFri">{{ 'catering.tagLactoseFree' | translate }}</span>
                    </div>
                  </td>
                  <td class="num">{{ kr(item.price) }}</td>
                  <td class="num muted">{{ item.min }}</td>
                  <td class="num qty-col">
                    <input class="qty" type="number" min="0"
                           [(ngModel)]="item.qty" (ngModelChange)="onQtyChange(item)">
                    <div class="qty-warn" *ngIf="item.qty > 0 && item.qty < item.min">
                      {{ 'catering.minWarning' | translate:{min: item.min} }}
                    </div>
                  </td>
                  <td class="num">{{ item.qty > 0 ? kr(item.qty * item.price) : '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="notice" *ngIf="menuPlanned && !items.length">
            <mat-icon>event_busy</mat-icon>
            <span>{{ 'catering.nothingAvailable' | translate }}</span>
          </div>

          <ng-container *ngIf="menuPlanned && items.length">
            <div class="form-row">
              <mat-form-field appearance="outline" class="desc-field">
                <mat-label>{{ 'catering.whatFor' | translate }}</mat-label>
                <input matInput [(ngModel)]="desciption" maxlength="30" [placeholder]="'catering.whatForPlaceholder' | translate">
                <mat-hint align="end">{{ desciption.length }}/30</mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="comment-field">
                <mat-label>{{ 'catering.comment' | translate }}</mat-label>
                <input matInput [(ngModel)]="comment" [placeholder]="'catering.commentPlaceholder' | translate">
              </mat-form-field>
            </div>

            <div class="notice" *ngIf="belowMin.length">
              <mat-icon>warning</mat-icon>
              <span>{{ (belowMin.length === 1 ? 'catering.belowMinOne' : 'catering.belowMinMany') | translate:{count: belowMin.length} }}</span>
            </div>

            <div class="notice" *ngIf="belowOrderMin">
              <mat-icon>warning</mat-icon>
              <span>{{ 'catering.belowOrderMin' | translate:{total: kr(total), min: kr(minOrderValueIncVat)} }}</span>
            </div>

            <div class="submit-row">
              <div class="total">
                <span class="total-label">{{ (lineCount === 1 ? 'catering.products' : 'catering.productsPlural') | translate:{count: lineCount} }}</span>
                <span class="total-value">{{ kr(total) }} kr</span>
                <span class="total-note">{{ 'catering.inclVat' | translate }}</span>
              </div>
              <span class="spacer"></span>
              <button mat-flat-button color="primary" [disabled]="!canSubmit" (click)="submit()">
                {{ (submitting ? 'catering.sendingOrder' : 'catering.sendOrder') | translate }}
              </button>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <!-- ---- what has been ordered ---- -->
    <h3 class="section-title">{{ 'catering.yourOrders' | translate }}</h3>

    <div class="state" *ngIf="!orders.length">{{ 'catering.nothingOrdered' | translate }}</div>

    <div class="table-wrap" *ngIf="orders.length">
      <table class="data">
        <thead>
          <tr>
            <th>{{ 'catering.colOrderDate' | translate }}</th>
            <th>{{ 'catering.colOrderNo' | translate }}</th>
            <th>{{ 'catering.colFor' | translate }}</th>
            <th>{{ 'catering.colProducts' | translate }}</th>
            <th class="num">{{ 'catering.colTotal' | translate }}</th>
            <th>{{ 'catering.colOrderStatus' | translate }}</th>
            <th class="row-actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let o of orders" [class.row-off]="o.status === 'Cancelled' || o.status === 'Rejected'">
            <td>{{ orderDate(o) }}</td>
            <td class="muted">{{ o.deliveryNumber }}</td>
            <td>
              <div>{{ o.desciption }}</div>
              <div class="prod-sub" *ngIf="o.systemName">{{ o.systemName }}</div>
            </td>
            <td class="products-cell">{{ productSummary(o) }}</td>
            <td class="num">{{ kr(o.totalIncVat) }}</td>
            <td>
              <span [class]="statusClass(o.status)">{{ statusLabel(o.status) }}</span>
              <div class="prod-sub" *ngIf="o.status === 'Rejected' && o.approval?.reason">
                {{ o.approval.reason }}
              </div>
              <div class="prod-sub" *ngIf="!cancellable(o) && (o.status === 'Pending approval' || o.status === 'Sheduled')">
                {{ 'catering.tooCloseToCancel' | translate }}
              </div>
            </td>
            <td class="row-actions">
              <button mat-icon-button *ngIf="cancellable(o)" (click)="cancel(o)"
                      [matTooltip]="'catering.tipCancel' | translate">
                <mat-icon>close</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </ng-container>
</div>
